import { UserAutomaticEmailType } from "@daytrip/legacy-enums";
import { Exclude, Expose } from "class-transformer";
import { IsDefined, IsInt } from "class-validator";

import { AutomaticEmail } from "./AutomaticEmail";

@Exclude()
export class UserAutomaticEmail extends AutomaticEmail<UserAutomaticEmailType> {
    @IsInt()
    @IsDefined()
    @Expose()
    public type: UserAutomaticEmailType;
}
